import Cookies from "js-cookie";

export const getOperationTypes = () => {
  return Cookies.get("operationTypes");
};
